import * as z from 'zod';

import { nullableBooleanQuerySchema } from '@/_schemas/generic';

export const inventoryCategoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),

  track_stock_quantities: nullableBooleanQuerySchema(),
  track_serial_numbers: nullableBooleanQuerySchema(),
});

export type InventoryCategoryQueryLinkerSchema = z.infer<typeof inventoryCategoryQueryLinkerSchema>;
